import { css as v, LitElement as f, html as l, nothing as u } from "lit";
import { property as s, customElement as m } from "lit/decorators.js";
import { classMap as b } from "lit/directives/class-map.js";
import { b as y } from "./styles-scZ6dVz-.js";
var k = Object.defineProperty, g = Object.getOwnPropertyDescriptor, h = (r, e, o, i) => {
  for (var t = i > 1 ? void 0 : i ? g(e, o) : e, c = r.length - 1, d; c >= 0; c--)
    (d = r[c]) && (t = (i ? d(e, o, t) : d(t)) || t);
  return i && t && k(e, o, t), t;
};
let p = class extends f {
  constructor() {
    super(...arguments), this.current = 0, this.orientation = "horizontal", this.clickable = !1, this.size = "md", this.handleStepClick = (r) => {
      this.clickable && this.dispatchEvent(
        new CustomEvent("ark-step-change", {
          detail: { index: r.detail.index },
          bubbles: !0,
          composed: !0
        })
      );
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("ark-step-click", this.handleStepClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("ark-step-click", this.handleStepClick);
  }
  firstUpdated() {
    this.updateSteps();
  }
  updated(r) {
    (r.has("current") || r.has("orientation") || r.has("clickable") || r.has("size")) && this.updateSteps();
  }
  updateSteps() {
    const r = this.querySelectorAll("ark-step"), e = r.length;
    r.forEach((o, i) => {
      const t = o;
      t.index = i, t.orientation = this.orientation, t.clickable = this.clickable, t.size = this.size, t.isLast = i === e - 1, i < this.current ? t.status = "finish" : i === this.current ? t.status = "process" : t.status = "wait";
    });
  }
  render() {
    const r = {
      steps: !0,
      [this.orientation]: !0
    };
    return l`
      <div part="steps" class=${b(r)} role="list">
        <slot></slot>
      </div>
    `;
  }
};
p.styles = [
  y,
  v`
      :host {
        display: block;
      }

      .steps {
        display: flex;
        gap: var(--r5-space-0);
      }

      .horizontal {
        flex-direction: row;
      }

      .vertical {
        flex-direction: column;
      }
    `
];
h([
  s({ type: Number, reflect: !0 })
], p.prototype, "current", 2);
h([
  s({ type: String, reflect: !0 })
], p.prototype, "orientation", 2);
h([
  s({ type: Boolean, reflect: !0 })
], p.prototype, "clickable", 2);
h([
  s({ type: String, reflect: !0 })
], p.prototype, "size", 2);
p = h([
  m("ark-steps")
], p);
var x = Object.defineProperty, w = Object.getOwnPropertyDescriptor, n = (r, e, o, i) => {
  for (var t = i > 1 ? void 0 : i ? w(e, o) : e, c = r.length - 1, d; c >= 0; c--)
    (d = r[c]) && (t = (i ? d(e, o, t) : d(t)) || t);
  return i && t && x(e, o, t), t;
};
let a = class extends f {
  constructor() {
    super(...arguments), this.index = 0, this.title = "", this.description = "", this.status = "wait", this.icon = "", this.orientation = "horizontal", this.clickable = !1, this.size = "md", this.isLast = !1, this.checkIcon = l`
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  `, this.errorIcon = l`
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  `;
  }
  handleClick() {
    this.clickable && this.dispatchEvent(
      new CustomEvent("ark-step-click", {
        detail: { index: this.index },
        bubbles: !0,
        composed: !0
      })
    );
  }
  renderIndicator() {
    return this.querySelector('[slot="icon"]') ? l`<slot name="icon"></slot>` : this.status === "finish" ? this.checkIcon : this.status === "error" ? this.errorIcon : this.index + 1;
  }
  render() {
    const r = {
      step: !0,
      [this.orientation]: !0,
      [this.status]: !0,
      [this.size]: !0,
      clickable: this.clickable,
      "is-last": this.isLast
    }, e = this.status === "finish" ? "connector finish" : "connector";
    return l`
      <div
        part="step"
        class=${b(r)}
        role="listitem"
        tabindex=${this.clickable ? 0 : -1}
        @click=${this.handleClick}
        @keydown=${(o) => {
      (o.key === "Enter" || o.key === " ") && (o.preventDefault(), this.handleClick());
    }}
      >
        <div class="indicator-wrapper">
          ${this.orientation === "horizontal" ? l`<div class=${e}></div>` : u}
          <div part="indicator" class="indicator">
            ${this.renderIndicator()}
          </div>
          <div class=${e}></div>
        </div>
        <div part="content" class="content">
          ${this.title ? l`<div part="title" class="title">${this.title}</div>` : u}
          ${this.description ? l`<div part="description" class="description">${this.description}</div>` : u}
          <slot></slot>
        </div>
      </div>
    `;
  }
};
a.styles = [
  y,
  v`
      :host {
        display: flex;
        flex: 1;
      }

      .step {
        display: flex;
        position: relative;
      }

      /* Horizontal layout */
      .horizontal {
        flex-direction: column;
        align-items: center;
        flex: 1;
      }

      .horizontal .indicator-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .horizontal .connector {
        flex: 1;
        height: 2px;
        background-color: var(--r5-border);
        transition: background-color var(--r5-duration-normal) var(--r5-ease-default);
      }

      .horizontal .connector.finish {
        background-color: var(--r5-primary);
      }

      .horizontal .connector:first-child {
        visibility: hidden;
      }

      .horizontal.is-last .connector:last-child {
        visibility: hidden;
      }

      /* Vertical layout */
      .vertical {
        flex-direction: row;
        gap: var(--r5-space-3);
      }

      .vertical .indicator-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .vertical .connector {
        flex: 1;
        width: 2px;
        min-height: var(--r5-space-6);
        background-color: var(--r5-border);
        transition: background-color var(--r5-duration-normal) var(--r5-ease-default);
      }

      .vertical .connector.finish {
        background-color: var(--r5-primary);
      }

      .vertical.is-last .connector {
        visibility: hidden;
      }

      /* Indicator */
      .indicator {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border-radius: var(--r5-radius-full);
        font-weight: var(--r5-font-medium);
        transition: all var(--r5-duration-normal) var(--r5-ease-default);
      }

      /* Sizes */
      .sm .indicator {
        width: 1.5rem;
        height: 1.5rem;
        font-size: var(--r5-text-xs);
      }

      .md .indicator {
        width: 2rem;
        height: 2rem;
        font-size: var(--r5-text-sm);
      }

      .lg .indicator {
        width: 2.5rem;
        height: 2.5rem;
        font-size: var(--r5-text-base);
      }

      /* Status: Wait */
      .wait .indicator {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text-muted);
        border: 2px solid var(--r5-border);
      }

      /* Status: Process */
      .process .indicator {
        background-color: var(--r5-primary);
        color: white;
        border: 2px solid var(--r5-primary);
      }

      /* Status: Finish */
      .finish .indicator {
        background-color: var(--r5-primary);
        color: white;
        border: 2px solid var(--r5-primary);
      }

      /* Status: Error */
      .error .indicator {
        background-color: var(--r5-danger);
        color: white;
        border: 2px solid var(--r5-danger);
      }

      .indicator svg {
        width: 60%;
        height: 60%;
      }

      /* Content */
      .content {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-0-5);
      }

      .horizontal .content {
        align-items: center;
        text-align: center;
        padding-top: var(--r5-space-2);
      }

      .vertical .content {
        padding-top: var(--r5-space-1);
        padding-bottom: var(--r5-space-4);
      }

      .title {
        font-weight: var(--r5-font-medium);
        color: var(--r5-text);
        transition: color var(--r5-duration-normal) var(--r5-ease-default);
      }

      .sm .title {
        font-size: var(--r5-text-xs);
      }

      .md .title {
        font-size: var(--r5-text-sm);
      }

      .lg .title {
        font-size: var(--r5-text-base);
      }

      .wait .title {
        color: var(--r5-text-muted);
      }

      .description {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        line-height: var(--r5-leading-normal);
      }

      /* Clickable */
      .clickable {
        cursor: pointer;
      }

      .clickable:hover .indicator {
        transform: scale(1.05);
      }

      .clickable:hover .title {
        color: var(--r5-primary);
      }

      .clickable:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: var(--r5-focus-ring-offset);
        border-radius: var(--r5-radius-md);
      }

      @media (prefers-reduced-motion: reduce) {
        .indicator,
        .title,
        .connector {
          transition: none;
        }
        .clickable:hover .indicator {
          transform: none;
        }
      }
    `
];
n([
  s({ type: Number })
], a.prototype, "index", 2);
n([
  s({ type: String })
], a.prototype, "title", 2);
n([
  s({ type: String })
], a.prototype, "description", 2);
n([
  s({ type: String, reflect: !0 })
], a.prototype, "status", 2);
n([
  s({ type: String })
], a.prototype, "icon", 2);
n([
  s({ type: String })
], a.prototype, "orientation", 2);
n([
  s({ type: Boolean })
], a.prototype, "clickable", 2);
n([
  s({ type: String })
], a.prototype, "size", 2);
n([
  s({ type: Boolean, attribute: "is-last" })
], a.prototype, "isLast", 2);
a = n([
  m("ark-step")
], a);
export {
  p as A,
  a
};
//# sourceMappingURL=ark-step-BBqLkrsv.js.map
